import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'wordToCamel'
})
export class WordToCamelPipe implements PipeTransform {
	transform(_value: any, _args?: unknown): any {
		return null;
	}
}
